import API from "../api";
import { PayloadNotificationListType } from "../types";
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async requestIsNotification(context: any): Promise<boolean> {
      const role = context.rootState.profile.me?.role;
      if (!role) return false;
      const { data } = await API.getIsNotification(role);
      return data;
    },
    async requestNotificationWasSeen(
      context: any,
      payload: number
    ): Promise<any> {
      const { data } = await API.getNotificationWasSeen(payload);
      return data;
    },
    async requestNotificationList(
      context: any,
      payload?: PayloadNotificationListType
    ): Promise<any> {
      const role = context.rootState.profile.me?.role;
      if (!role) return null;
      const { data } = await API.getNotificationList(role, payload);
      return data;
    },
    async requestNotificationConfigure(
      context: any,
      payload: any
    ): Promise<any> {
      const role = context.rootState.profile.me?.role;
      if (!role) return null;
      const { data } = await API.putNotificationConfigure(role, payload);
      return data;
    },
    async requestNotificationConfig(context: any): Promise<any> {
      const role = context.rootState.profile.me?.role;
      if (!role) return null;
      const { data } = await API.getNotificationConfig(role);
      return data;
    },
    async requestIsMessageNotification(): Promise<boolean> {
      const { data } = await API.getIsMessageNotification();
      return data;
    },
    async requestNotificationRead(context: any, payload: number): Promise<any> {
      const role = context.rootState.profile.me?.role;
      if (!role) return null;
      const { data } = await API.patchNotificationRead(role, payload);
      return data;
    },
    async requestNotificationUnread(
      context: any,
      payload: number
    ): Promise<any> {
      const role = context.rootState.profile.me?.role;
      if (!role) return null;
      const { data } = await API.patchNotificationUnread(role, payload);
      return data;
    },
    async requestNotificationDelete(
      context: any,
      payload: number
    ): Promise<any> {
      const role = context.rootState.profile.me?.role;
      if (!role) return null;
      const { data } = await API.deleteNotification(role, payload);
      return data;
    },
    async requestNotificationAllRead(context: any): Promise<any> {
      const role = context.rootState.profile.me?.role;
      if (!role) return null;
      const { data } = await API.patchNotificationAllRead(role);
      return data;
    },
  },
  modules: {},
};
